export enum TreasuryTransactionCategory {
  Internal = "Internal",
  InvestPool = "InvestPool",
  CexOrders = "CexOrders",
  CexLatestTrades = "CexLatestTrades",
}

export const TreasuryTransactionCategories = Object.values(
  TreasuryTransactionCategory
);

export function toTreasuryTransactionCategoryIndex(
  category: TreasuryTransactionCategory
) {
  return TreasuryTransactionCategories.indexOf(category);
}
